import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Company } from '@app/core/business/company/company';
import { CompanyService } from '@app/core/business/company/company.service';
import { ContextService } from '@app/core/service/context.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dialog-order-creation',
  templateUrl: './dialog-order-creation.component.html',
  styleUrls: ['./dialog-order-creation.component.scss']
})
export class DialogOrderCreationComponent implements OnInit {
  

  companyName: string;
  logoPath: string = environment.defaultLogoUrl;
  question: string = "";
  couleur: string = "#000000";
  selectableCompanies$: Observable<Company[]>;
  otherCompanyIsVitafrais: boolean = false;
 

  constructor( public dialogRef: MatDialogRef<DialogOrderCreationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contextService: ContextService,
    private translateService : TranslateService,
    private companyService: CompanyService) {
 }
    
    /**
     * OnInit lifecycle hook
    */
    ngOnInit(): void {

    if(this.data.otherCompany) {
      if(this.data.otherCompany === "VITAFRAIS")
      {
        this.otherCompanyIsVitafrais = true;
        this.companyName = "VITAFRAIS";
        this.question = this.translateService.instant("order.orderTootherCompanyQuestionPRONATURA");
        this.couleur = "#015daa";
      }
      // companyName = "PRONATURA"
      else {
        this.otherCompanyIsVitafrais = false;
        this.question = this.translateService.instant("order.orderTootherCompanyQuestionVITAFRAIS");
        this.couleur = "#771b59";
      }
    }
    
    this.companyService.getAvailableCompanies$().subscribe((companies) => {
      this.logoPath = environment.baseFileUrl + companies[0].picture.url;
    });

    }

  /**
   * Close the dialog
   */
  closeDialog(): void {
    this.dialogRef.close();
  }

}
